
//export const API_DOMAIN = 'modernartsmidtown-local.dev.dynamic.ms';
//export const API_DOMAIN = 'modernartsmidtown.com';
//export const API_URI = `https://${API_DOMAIN}`;
export const API_URI = '';
